// **************************************************
import { Injectable, } from '@angular/core';
import * as Setting from '../../../assets/settings.json';
import { TablePaging } from '../models/table-paging';
import { ApiResponseTable } from '../models/api-response-table';
import * as Interfaces from '../interfaces/table';
import { TableBody } from '../models/table-body';
import { LoggerService } from 'src/app/services/logger.service';
// **************************************************

@Injectable({
  providedIn: 'root',
})

export class CustomizeResponseService {

  public constructor(private logger: LoggerService) {
  }

  public data: any = Setting;

  public customizePaging(apiResponse: ApiResponseTable): any {
    let tablePaging = new TablePaging();
    try {
      let minValue = 1;
      let maxValue = 10;

      if (apiResponse.data?.totalItemCount==0) {
        tablePaging.empty = true;
      } else {
        tablePaging.empty = false;
      }

      if (apiResponse.data?.isFirstPage != null) {
        tablePaging.first = apiResponse.data.isFirstPage;
      } else {
        tablePaging.first = false;
      }

      if (apiResponse.data?.isLastPage != null) {
        tablePaging.last = apiResponse.data.isLastPage;
      } else {
        tablePaging.last= false;
      }

      if (apiResponse.data?.pageNumber != null) {
        tablePaging.pageNumber = apiResponse.data.pageNumber;
      } else {
        tablePaging.pageNumber= 0;
      }

      if (apiResponse.data?.pageSize != null) {
        tablePaging.pageSize = apiResponse.data.pageSize;
      } else {
        tablePaging.pageSize= 0;
      }

      if (apiResponse.data?.totalItemCount != null) {
        tablePaging.totalElements = apiResponse.data.totalItemCount;
      } else {
        tablePaging.totalElements= 0;
      }

      if (apiResponse.data?.pageCount != null) {
        tablePaging.totalPages = apiResponse.data.pageCount;
      } else {
        tablePaging.totalPages= 0;
      }
      

      if (tablePaging.totalPages == 1) {
        tablePaging.pagingList.push(1);
        return tablePaging;
      }

      if (tablePaging.pageNumber > 5) {
        minValue = tablePaging.pageNumber - 5;
        if (tablePaging.totalPages >= tablePaging.pageNumber + 5) {
          maxValue = tablePaging.pageNumber + 5;
        } else {
          maxValue = tablePaging.totalPages;
        }
      } else if (tablePaging.totalPages < 10) {
        maxValue = tablePaging.totalPages;
      }

      for (let index = minValue; index <= maxValue; index++) {
        tablePaging.pagingList.push(index);
      }

    } catch (error) {
      this.logger.addException(error, true);
    }

    return tablePaging;
  }

  public customizePagingSpecificRecord(apiResponse: ApiResponseTable,recordCount:number):any{
    let tablePaging = new TablePaging();
    try {
      let minValue = 1;
      let maxValue = recordCount;

      if (apiResponse.data?.totalItemCount==0) {
        tablePaging.empty = true;
      } else {
        tablePaging.empty = false;
      }

      if (apiResponse.data?.isFirstPage != null) {
        tablePaging.first = apiResponse.data.isFirstPage;
      } else {
        tablePaging.first = false;
      }

      if (apiResponse.data?.isLastPage != null) {
        tablePaging.last = apiResponse.data.isLastPage;
      } else {
        tablePaging.last= false;
      }

      if (apiResponse.data?.pageNumber != null) {
        tablePaging.pageNumber = apiResponse.data.pageNumber;
      } else {
        tablePaging.pageNumber= 0;
      }

      if (apiResponse.data?.pageSize != null) {
        tablePaging.pageSize = apiResponse.data.pageSize;
      } else {
        tablePaging.pageSize= 0;
      }

      if (apiResponse.data?.totalItemCount != null) {
        tablePaging.totalElements = apiResponse.data.totalItemCount;
      } else {
        tablePaging.totalElements= 0;
      }

      if (apiResponse.data?.pageCount != null) {
        tablePaging.totalPages = apiResponse.data.pageCount;
      } else {
        tablePaging.totalPages= 0;
      }
      

      if (tablePaging.totalPages == 1) {
        tablePaging.pagingList.push(1);
        return tablePaging;
      }

      const half=maxValue/2;
      if (tablePaging.pageNumber > half) {
        minValue = tablePaging.pageNumber - half;
        if (tablePaging.totalPages >= tablePaging.pageNumber + half) {
          maxValue = tablePaging.pageNumber + half;
        } else {
          maxValue = tablePaging.totalPages;
        }
      } else if (tablePaging.totalPages < maxValue) {
        maxValue = tablePaging.totalPages;
      }

      for (let index = minValue; index <= maxValue; index++) {
        tablePaging.pagingList.push(index);
      }

    } catch (error) {
      this.logger.addException(error, true);
    }

    return tablePaging;
  }

  public customizeData(apiResponse: Interfaces.TableData): any {
    try {
      for (let row = 0; row < apiResponse.tableBody.length; row++) {

        var thisItem = new TableBody(apiResponse.tableBody[row].id);
        thisItem.rowNum = row + 1;

        for (let column = 0; column < apiResponse.tableHeader.length; column++) {

          if (!apiResponse.tableHeader[column].hide) {
            thisItem.data.push(apiResponse.tableBody[row].data[column]);
            if (row == 0) {
              apiResponse.tableShowHeader.push(apiResponse.tableHeader[column]);
            }
          }

        }

        apiResponse.tableShowBody.push(thisItem);
      }
    } catch (e) {
      this.logger.addException(e, true);
    }

    return apiResponse;
  }

  public customizeHeader(content: any): any {
    return Object.keys(content)
      .map(key => ({ order: 1, name: key, width: 0, sort: '', hide: false }));
  }

  public customizeRow(content: any[], startIndex: number): any {
    let tableRow: Interfaces.TableBody[] = [];
    content!.forEach(element => {

      tableRow.push(
        {
          rowNum: startIndex,
          id: element['id'],
          data: Object.keys(element).map(key => (element[key]))
        }
      )

      startIndex++;
    });

    return tableRow;
  }

  public customizeUpdate(content: any): any {
    return Object.keys(content)
      .map(key => ({ label: key, fieldType: "text", defaultValue: [], key: key, value: content[key], isRequierd: false }));
  }
  public customizeAdd(content: any): any {
    return Object.keys(content)
      .map(key => ({ label: key, fieldType: "text", defaultValue: [], key: key, value: "", isRequierd: false }));
  }
}